import { useRef, useState } from 'react';

interface PlayerDemoProps {
  poster: string;
  title: string;
}

export default function PlayerDemo({ poster, title }: PlayerDemoProps) {
  const [toast, setToast] = useState(false);
  const timer = useRef<ReturnType<typeof setTimeout> | null>(null);

  const handlePlay = () => {
    setToast(true);
    if (timer.current) clearTimeout(timer.current);
    timer.current = setTimeout(() => setToast(false), 2400);
  };

  return (
    <div>
      <button
        type="button"
        onClick={handlePlay}
        aria-label={`播放 ${title}`}
        className="group relative block w-full overflow-hidden rounded-lg border border-background-200"
      >
        <div className="relative aspect-video w-full bg-foreground-950">
          <img
            src={poster}
            alt={`${title} 播放演示区`}
            className="h-full w-full object-cover object-top opacity-70"
          />
          <div className="absolute inset-0 bg-foreground-950/35" />
          <div className="absolute inset-0 flex flex-col items-center justify-center gap-3">
            <span className="flex h-16 w-16 items-center justify-center rounded-full bg-primary-500/90 text-background-50 transition-transform duration-300 group-hover:scale-110 md:h-20 md:w-20">
              <i className="ri-play-fill text-3xl md:text-4xl" />
            </span>
            <span className="rounded-full bg-foreground-950/60 px-3 py-1 text-xs text-background-50">
              播放演示区 · 点击体验
            </span>
          </div>
        </div>
      </button>
      <p className="mt-3 flex items-center gap-2 text-xs text-foreground-500 md:text-sm">
        <i className="ri-information-line text-base text-accent-600" />
        播放功能演示，待接入真实视频源，当前点击不会播放真实内容。
      </p>

      {toast && (
        <div className="fixed bottom-24 left-1/2 z-[60] -translate-x-1/2 rounded-md bg-foreground-950/90 px-5 py-3 text-sm text-background-50 md:bottom-10">
          <i className="ri-error-warning-line mr-1 text-accent-400" /> 播放功能演示，待接入
        </div>
      )}
    </div>
  );
}